import styled from 'styled-components';

export const AmenitiesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 10px 0 2rem;
`;

export const AmenitiesItem = styled.div`
  display: flex;
  align-items: center;
  width: 190px;
  flex-basis: 25%;
  padding-top: 10px;
`;

export const AmenitiesIcon = styled.img`
  margin-right: 5px;
`;

export const AmenitiesText = styled.span``;
